export default __webpack_public_path__ + "e8cafc9fb3d2f86f7943a59089ae5e63.png";